import { Code, Loader, Modal, Stack, Text } from '@mantine/core';
import { useCustom } from '@refinedev/core';
import { AdminBackgroundProcessDetail } from './types';

type BackgroundProcessDetailModalProps = {
  processId: string | null;
  companyId: string;
  onClose: () => void;
};

function MetadataRow({ label, value }: { label: string; value: string | null | undefined }) {
  const displayValue = value === null || value === undefined ? '-' : value;
  return (
    <Text size="sm" style={{ fontFamily: 'monospace' }}>
      <Text span fw={600}>
        {label}:
      </Text>{' '}
      {displayValue}
    </Text>
  );
}

export function BackgroundProcessDetailModal({
  processId,
  companyId,
  onClose,
}: BackgroundProcessDetailModalProps) {
  const { data, isLoading } = useCustom<AdminBackgroundProcessDetail>({
    url: `admin/companies/${companyId}/background-processes/${processId}`,
    method: 'get',
    queryOptions: {
      enabled: !!processId,
    },
  });

  const process = data?.data;

  return (
    <Modal
      opened={!!processId}
      onClose={onClose}
      title={`Background Process: ${process?.processName ?? ''}`}
      size={800}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Stack gap="md">
          <Stack gap="xs">
            <MetadataRow label="ID" value={process?.id} />
            <MetadataRow label="Process Name" value={process?.processName} />
            <MetadataRow label="Status" value={process?.status} />
            <MetadataRow label="Status Message" value={process?.statusMessage} />
          </Stack>

          {process?.extraDetails && (
            <Stack gap="xs">
              <Text size="sm" fw={600}>
                Extra Details:
              </Text>
              <Code block style={{ maxHeight: '50vh', maxWidth: '100%', overflow: 'auto' }}>
                {JSON.stringify(process.extraDetails, null, 2)}
              </Code>
            </Stack>
          )}
        </Stack>
      )}
    </Modal>
  );
}
